import React, { useState, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useTheme } from '~/ui/styled'
import { ColumnFlex, StartFlex, BetweenFlex, CenterFlex, Text, Button } from "~components/El"
import { SearchBar } from "~components/SearchBar"
import { FlatList } from "~widgets/flat-list"
import { useStores } from "~models"
import ContactListCartItem from "~/components/contact-list/components/Contact-list-cart-item"

const ContactListViewCard: React.FC<{
    title?: string
    confirmText?: string
    onConfirm: (contacts: any[]) => void
    onClose: () => void
}> = ({ title = "选择要分享的联系人", confirmText = "添加", onConfirm, onClose }) => {
    const theme = useTheme()
    const { contactStore } = useStores()
    const [searchText, setSearchText] = useState("")
    const [selecteds, setSelecteds] = useState([])
    const data = contactStore.getContactListByKeyword(searchText)

    const onItemClick = useCallback((contact) => {
        const index = selecteds.findIndex(item => item.user_id === contact.user_id)
        if (index !== -1) {
            selecteds.splice(index, 1)
            setSelecteds([...selecteds])
        } else {
            selecteds.push(contact)
            setSelecteds([...selecteds])
        }
    }, [selecteds])
    
    const keyExtractor = useCallback((item, idx) => item.user_id || idx.toString(), [])
    return (
        <ColumnFlex
            width="100%"
            padding="20px"
            borderRadius="16px"
            bg={theme.colors.blockBackground}
        >
            <CenterFlex height="auto" width="100%">
                <Text fontSize="16px" color={theme.colors.text} fontWeight={600}>{title}</Text>
            </CenterFlex>
            <StartFlex height="auto" width="100%" mt="20px">
                <SearchBar
                    value={searchText}
                    placeholder="搜索联系人"
                    onChange={setSearchText}
                    onClear={() => setSearchText("")}
                />
            </StartFlex>
            <ColumnFlex width="100%" height="360px" alignItems="stretch" style={{ overflow: "hidden", minHeight: 0 }}>
                <FlatList
                      data={data}
                      extraData={selecteds}
                      keyExtractor={keyExtractor}
                      renderItem={({ item }) => {
                        return (
                          <ContactListCartItem contact={item} selecteds={selecteds} isSelectMode={true} onItemClick={onItemClick} />
                        )
                      }}
                    />
            </ColumnFlex>
            <BetweenFlex height="auto" width="100%" mt="12px" gap="10px">
                <Button
                    flex="1"
                    height="44px"
                    borderRadius={theme.radii.lg}
                    bg={theme.colors.background}
                    onClick={onClose}
                >
                    <Text color={theme.colors.infoText} fontSize={16}>取消</Text>
                </Button>
                <Button
                    flex="1"
                    height="44px"
                    borderRadius={theme.radii.lg}
                    bg={theme.colors.primary}
                    disabled={selecteds.length === 0}
                    onClick={() => onConfirm(selecteds)}
                >
                    <Text color={theme.colors.textLight} fontSize={16}>{confirmText}{selecteds.length > 0 && <Text>({selecteds.length}人)</Text>}</Text>
                </Button>
            </BetweenFlex>
        </ColumnFlex>
    )
}

export default observer(ContactListViewCard)
